module.exports = __webpack_public_path__ + "static/img/linlu.6ecf0617.png";